import { render, staticRenderFns } from "./WorkDecimalTextField.vue?vue&type=template&id=0d485939&scoped=true"
import script from "./WorkDecimalTextField.vue?vue&type=script&lang=js"
export * from "./WorkDecimalTextField.vue?vue&type=script&lang=js"
import style0 from "./WorkDecimalTextField.vue?vue&type=style&index=0&id=0d485939&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d485939",
  null
  
)

export default component.exports